var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ValidationProvider',{attrs:{"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-select',{attrs:{"items":_vm.statuses,"item-text":item => {
					if (item.text) {
						return _vm.$t(`pipeline.steps.${item.text}`);
					}
					return item;
				},"item-value":"value","label":_vm.label,"outlined":"","hide-details":"","dense":"","disabled":_vm.disabled,"prepend-inner-icon":_vm.innerIcon,"error-messages":errors},on:{"change":newVal => _vm.handleChange({ newVal })},model:{value:(_vm.currentStatus),callback:function ($$v) {_vm.currentStatus=$$v},expression:"currentStatus"}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }